<div class="mini-wrapper">
  <div class="sub-wrapper">
    <h1 class="landing mb-4 text-center">{{ 'norights.title' | transloco }}</h1>
    <div class="mt-3 mb-4">
      <p class="fw-bolder">{{ 'dearUser' | transloco }}</p>
      <div class="translate">{{ 'norights.accountDeleted' | transloco }}</div>
    </div>

    <app-contacts-info></app-contacts-info>

    <button class="primary xl w-100 mt-3 logout-btn" disableRipple [routerLink]="['/']" data-test="norights_btn-logout">
      {{ 'norights.button_auto' | transloco }}
    </button>
  </div>
</div>

